export default __webpack_public_path__ + "static/media/close.f5ba8d48.svg";